<template>
    <u-swiper-pagination-ellipse v-bind="$attrs" class="swiper-pagination--sm">
        <slot />
    </u-swiper-pagination-ellipse>
</template>

<script>
import USwiperPaginationEllipse from "@/components/publish/styles/swipers/u-swiper-pagination-ellipse.vue";

export default {
    props: {},
    components: {
        USwiperPaginationEllipse,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
